import { render, staticRenderFns } from "./TypeIbCard.vue?vue&type=template&id=259f6bca&"
import script from "./TypeIbCard.vue?vue&type=script&lang=js&"
export * from "./TypeIbCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports